import { Injectable } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject } from 'rxjs';
import { scan, map, distinctUntilChanged } from 'rxjs/operators';
import { FullScreenLoaderComponent } from './full-screen-loader/full-screen-loader.component';

@Injectable({
  providedIn: 'root'
})
export class FullScreenLoaderService {
  private overlayRef = this.overlay.create({
    hasBackdrop: true,
    backdropClass: 'fullscreen-spinner-backdrop',
    panelClass: 'fullscreen-spinner-panel',
    disposeOnNavigation: true,
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
  });

  private load$ = new Subject<number>();

  constructor(private overlay: Overlay) {
    this.load$
      .pipe(
        scan((acc, next) => {
          if (!next) return 0;
          return acc + next >= 0 ? acc + next : 0;
        }, 0),
        map((val) => val > 0),
        distinctUntilChanged()
      )
      .subscribe((res) => {
        if (res) {
          this.overlayRef.attach(new ComponentPortal(FullScreenLoaderComponent));
        } else if (this.overlayRef.hasAttached()) {
          this.overlayRef.detach();
        }
      });
  }

  show = () => this.load$.next(1);

  hide = () => this.load$.next(-1);

  reset = () => this.load$.next(0);
}
